export const normalizeInput = (value:any) => {
    if (!value) return value;
  
    // HubSpot stores numbers like "+1 (646) 709-7602"; drop the US country code.
    // A US area code never starts with 1, so a leading 1 is always the country code.
    const currentValue = value.replace(/[^\d]/g, '').replace(/^1/, '');
    const cvLength = currentValue.length;
  
    
    if (cvLength < 4) return currentValue;
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
  
    
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  
  };


  export const formatDOB = (value: string) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 0) return "";
    if (digits.length <= 2) return digits;                   // M
    if (digits.length <= 4) return `${digits.slice(0,2)}/${digits.slice(2)}`;  // MM/DD
    return `${digits.slice(0,2)}/${digits.slice(2,4)}/${digits.slice(4,8)}`;   // MM/DD/YYYY
  };
  

 export const convertFromISOToUS = (iso: string) => {
    if (!iso) return "";
    const [year, month, day] = iso.split("-");
    return `${month}/${day}/${year}`;
  };
  

  export const isValidDOB = (dob: string): boolean => {
    if (!dob || dob.length !== 10) return false;
  
    const [month, day, year] = dob.split("/").map(Number);
  
    if (!month || !day || !year) return false;
    if (month < 1 || month > 12) return false;
    if (year < 1900 || year > new Date().getFullYear()) return false;
  
    const constructed = new Date(year, month - 1, day);
  
    // Check if the date object matches the input exactly (no overflow)
    const matches =
      constructed.getFullYear() === year &&
      constructed.getMonth() === month - 1 &&
      constructed.getDate() === day;
  
    if (!matches) return false;
  
    // Optional: age restriction
    const age = new Date().getFullYear() - year;
    if (age < 5 || age > 120) return false;
  
    return true;
  };


  export function usDateToTimestamp(usDate: string): number | null {
    if (!usDate) return null;

    // Expecting format: MM/DD/YYYY
    const [mm, dd, yyyy] = usDate.split("/").map((part) => parseInt(part, 10));
  
    if (!mm || !dd || !yyyy) return null;
  
    // Date.UTC(year, monthIndex (0-based), day) -> ms at *midnight UTC*
    return Date.UTC(yyyy, mm - 1, dd);
  }


  export const isUnder25 = (dobUS: string) => {
    // expects MM/DD/YYYY
    const [mm, dd, yyyy] = dobUS.split("/").map(Number);
    if (!mm || !dd || !yyyy) return false;
  
    const dob = new Date(yyyy, mm - 1, dd);
  
    // reject invalid dates like 02/31/2001
    if (
      dob.getFullYear() !== yyyy ||
      dob.getMonth() !== mm - 1 ||
      dob.getDate() !== dd
    ) return false;
  
    const today = new Date();
  
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
  
    return age < 25;
  };



export const usaStates = [
  {
    label: "Alabama",
    value: "AL"
  },
  {
    label: "Alaska",
    value: "AK"
  },
  {
    label: "Arizona",
    value: "AZ"
  },
  {
    label: "Arkansas",
    value: "AR"
  },
  {
    label: "California",
    value: "CA"
  },
  {
    label: "Colorado",
    value: "CO"
  },
  {
    label: "Connecticut",
    value: "CT"
  },
  {
    label: "District of Columbia",
    value: "DC"
  },
  {
    label: "Delaware",
    value: "DE"
  },
  {
    label: "Florida",
    value: "FL"
  },
  {
    label: "Georgia",
    value: "GA"
  },
  {
    label: "Hawaii",
    value: "HI"
  },
  {
    label: "Idaho",
    value: "ID"
  },
  {
    label: "Illinois",
    value: "IL"
  },
  {
    label: "Indiana",
    value: "IN"
  },
  {
    label: "Iowa",
    value: "IA"
  },
  {
    label: "Kansas",
    value: "KS"
  },
  {
    label: "Kentucky",
    value: "KY"
  },
  {
    label: "Louisiana",
    value: "LA"
  },
  {
    label: "Maine",
    value: "ME"
  },
  {
    label: "Maryland",
    value: "MD"
  },
  {
    label: "Massachusetts",
    value: "MA"
  },
  {
    label: "Michigan",
    value: "MI"
  },
  {
    label: "Minnesota",
    value: "MN"
  },
  {
    label: "Mississippi",
    value: "MS"
  },
  {
    label: "Missouri",
    value: "MO"
  },
  {
    label: "Montana",
    value: "MT"
  },
  {
    label: "Nebraska",
    value: "NE"
  },
  {
    label: "Nevada",
    value: "NV"
  },
  {
    label: "New Hampshire",
    value: "NH"
  },
  {
    label: "New Jersey",
    value: "NJ"
  },
  {
    label: "New Mexico",
    value: "NM"
  },
  {
    label: "New York",
    value: "NY"
  },
  {
    label: "North Carolina",
    value: "NC"
  },
  {
    label: "North Dakota",
    value: "ND"
  },
  {
    label: "Ohio",
    value: "OH"
  },
  {
    label: "Oklahoma",
    value: "OK"
  },
  {
    label: "Oregon",
    value: "OR"
  },
  {
    label: "Pennsylvania",
    value: "PA"
  },
  {
    label: "Puerto Rico",
    value: "PR"
  },
  {
    label: "Rhode Island",
    value: "RI"
  },
  {
    label: "South Carolina",
    value: "SC"
  },
  {
    label: "South Dakota",
    value: "SD"
  },
  {
    label: "Tennessee",
    value: "TN"
  },
  {
    label: "Texas",
    value: "TX"
  },
  {
    label: "Utah",
    value: "UT"
  },
  {
    label: "Vermont",
    value: "VT"
  },
  {
    label: "Virginia",
    value: "VA"
  },
  {
    label: "Washington",
    value: "WA"
  },
  {
    label: "West Virginia",
    value: "WV"
  },
  {
    label: "Wisconsin",
    value: "WI"
  },
  {
    label: "Wyoming",
    value: "WY"
  }
];